import { addWishlistItemTagAction } from "@/actions/wishlist";
import { useMarket } from "@app/_context";
import useAuth from "@features/auth/hooks/useAuth";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import invalidateWishlistQueries from "../utils/invalidateWishlistQueries";

export default function useAddWishlistItemTag() {
  const { market } = useMarket().state;
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isSuccess } = useMutation({
    mutationFn: async ({
      tagId,
      productId,
      variantId,
    }: {
      tagId: number;
      productId: string;
      variantId?: string;
    }) => {
      if (!token) return;

      return addWishlistItemTagAction({
        token,
        locale: market.serviceLocale,
        payload: { tagId, productId, variantId },
      });
    },
    onSettled: () => invalidateWishlistQueries(queryClient),
  });

  const addWishlistItemTag = useCallback(
    (payload: { tagId: number; productId: string; variantId?: string }) => {
      mutate(payload);
    },
    [mutate],
  );

  const addWishlistItemTagAsync = useCallback(
    (payload: { tagId: number; productId: string; variantId?: string }) => {
      return mutateAsync(payload);
    },
    [mutateAsync],
  );

  return {
    addWishlistItemTag,
    addWishlistItemTagAsync,
    isPending,
    isSuccess,
  };
}
